/* tslint:disable */
/* eslint-disable */
export enum ProjectItemSubmittalOwnerStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
  Resubmit = 'Resubmit'
}
